var def = require('./_object-dp').f
  , has = require('./_has')
  , TAG = require('./_wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};


//////////////////
// WEBPACK FOOTER
// C:/apache/localhost/www/Angular/task2/~/core-js/modules/_set-to-string-tag.js
// module id = ../../../../core-js/modules/_set-to-string-tag.js
// module chunks = 0